import { getApplicationStateIdentifier } from '@resistdesign/voltra/app/utils';

const READ = getApplicationStateIdentifier();
const SAVE = getApplicationStateIdentifier();
const DELETE = getApplicationStateIdentifier();
const RESUME_UPLOAD_URL = getApplicationStateIdentifier();
const AUDIO_SAMPLE_UPLOAD_URL = getApplicationStateIdentifier();

export const PROFILE = getApplicationStateIdentifier({
  READ,
  SAVE,
  DELETE,
  RESUME_UPLOAD_URL,
  AUDIO_SAMPLE_UPLOAD_URL,
});
